const weather = document.querySelector(".weather-items");

export default {
  init: () => {
    if (weather) {
      const url =
        "https://api.open-meteo.com/v1/forecast?latitude=40.673&longitude=-73.946&current=temperature_2m,precipitation,relative_humidity_2m,wind_speed_10m&daily=uv_index_max&temperature_unit=fahrenheit&wind_speed_unit=mph&precipitation_unit=inch&timeformat=unixtime&timezone=America%2FNew_York&forecast_days=1";

      fetch(url)
        .then((response) => response.json())
        .then((data) => {
          document.querySelector(".data-temp").innerText = data.current.temperature_2m;
          document.querySelector(".data-percip").innerText = data.current.precipitation;
          document.querySelector(".data-humidity").innerText = data.current.relative_humidity_2m;
          document.querySelector(".data-wind").innerText = data.current.wind_speed_10m;
        })
        .catch((error) => {
          console.error("Error: ", error);
        });
    }
  },
};
